import { providePlaceholders } from '../enhancers/providePlaceholders';
/**
 * Vue plugins must export a function named 'install'
 *
 * @param {App} app
 * @param {SitecoreJssPlaceholderPluginOptions} options
 */
function install(app, options) {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$jss = Object.assign(Object.assign({}, app.config.globalProperties.$jss), { componentFactory: options && options.componentFactory });
    app.mixin({
        beforeCreate() {
            providePlaceholders(this, options && options.componentFactory);
        },
    });
}
export const SitecoreJssPlaceholderPlugin = {
    install,
};
